import React from 'react';
import SectionTitle from './SectionTitle';

const About = () => {
  return (
    <section id="about" className="section pt-5 mt-5">
      <div className="container">
        <SectionTitle title="About Mira Pearls" />
        <div className="row">
          <div className="col-md-8 mx-auto" style={{ textAlign: 'justify' }}>
            <p>
            MIRA PEARLS is a proudly Australian wholesale supplier specializing in the finest White South Sea, Tahitian, and Golden South Sea Pearls. With over 10 years of expertise, we source and distribute high-quality loose pearls and pearl jewelry to jewelers, designers, and businesses worldwide.
            </p>
            <p>
            Based in Sydney, we are committed to authenticity, excellence, and ethical sourcing, ensuring that every pearl meets the highest standards of luster, quality, and craftsmanship. Our wholesale collections provide businesses with premium-grade pearls that enhance their jewelry designs and meet the growing demand for luxury pearl products.
            </p>
            <p>
            As a trusted bulk supplier, MIRA PEARLS partners with retailers, manufacturers, and distributors who seek exceptional pearls for their collections. Whether you need hand-selected loose pearls or expertly crafted pearl jewelry, we deliver wholesale excellence with a commitment to quality and reliability.
            </p>
            <p>
            <b>Partner with MIRA PEARLS—your trusted source for premium wholesale pearls.</b>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;